module.exports = __webpack_public_path__ + "static/media/Weavile_gaussian2.85a380d9.png";